import { get, post, put, patch, del } from '../http/http';
// 流量控制
export default {
    getList: (val) => get('/flow-control', val), // 查询列表
    addList: (val) => post('/flow-control', val), // 添加
    delList: (val) => del(`/flow-control/${val}`), // 删除
    putList: (val) => put(`/flow-control/${val.id}`, val), // 编辑
    getInfo: (val) => get(`/flow-control/${val}`), // 详情
    bindApis: (id, val) => post(`/flow-control/${id}/apis`, val), // 批量绑定API
    unbindApi: (id, val) => del(`/flow-control/${id}/api/${val.id}`), // 解绑API
    getInfoApiList: (id, val) => get(`/flow-control/${id}/apis`, val), // 查询流量控制的API
    getInfoAppList: (val) => get(`/flow-control/${val}/rate`), // 查询流量控制的应用
    bindApp: (id, val) => post(`/flow-control/${id}/rate`, val), // 绑定应用
    unbindApp: (id, val) => del(`/flow-control/${id}/rate/${val.id}`), // 解绑应用
    updateApp: (id, val) => put(`/flow-control/${id}/rate/${val.id}`, val) // 流控限制-修改
}